import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import ThemeToggle from './components/ThemeToggle'
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Info from './pages/Info';
import Partners from './pages/Partners';
import WallOfChampions from './pages/WallOfChampions';
import Paasarja from './pages/Paasarja';
import ShuffleCup from './pages/ShuffleCup';
import Touge from './pages/Touge';
import HotlapHontsa from './pages/HotlapHontsa';
import { AdminProvider } from './auth/AdminContext';
import AdminPanel from './pages/AdminPanel';
import { getContent, getVisibilities } from './services/api';

function App() {
  const [pageTitles, setPageTitles] = useState({
    paasarja: "Pääsarja",
    shuffle_cup: "Shuffle Cup",
    touge: "Touge",
    hotlap_hontsa: "Hotlap & Höntsä",
    wall_of_champions: "Hall of Fame",
  });

  const [pageVisibilities, setPageVisibilities] = useState({});

  useEffect(() => {
    const keys = Object.keys(pageTitles);
    Promise.all([
      ...keys.map(key => getContent(`title_${key}`)),
      getVisibilities()
    ])
    .then(results => {
      const visibilities = results.pop();
      setPageVisibilities(visibilities);

      const newTitles = { ...pageTitles };
      results.forEach((data, index) => {
        if (data && data.body) {
          newTitles[keys[index]] = data.body;
        }
      });
      setPageTitles(newTitles);
    })
    .catch(() => {});
  }, []);

  const handleTitleUpdate = (key, newTitle) => {
    const updatedTitles = { ...pageTitles, [key]: newTitle };
    setPageTitles(updatedTitles);
  };

  return (
    <AdminProvider>
      <Router>
        <div className="App">
          <Header />
          <ThemeToggle />
          <Navigation titles={pageTitles} visibilities={pageVisibilities} />
          <main>
            <div className="content-wrapper">
              <Routes>
                <Route path="/" element={<Info titles={pageTitles} visibilities={pageVisibilities} />} />
                <Route path="/info" element={<Info titles={pageTitles} visibilities={pageVisibilities} />} />
                <Route path="/paasarja" element={<Paasarja title={pageTitles.paasarja} onTitleUpdate={(newTitle) => handleTitleUpdate('paasarja', newTitle)} />} />
                <Route path="/shuffle-cup" element={<ShuffleCup title={pageTitles.shuffle_cup} onTitleUpdate={(newTitle) => handleTitleUpdate('shuffle_cup', newTitle)} />} />
                <Route path="/touge" element={<Touge title={pageTitles.touge} onTitleUpdate={(newTitle) => handleTitleUpdate('touge', newTitle)} />} />
                <Route path="/partners" element={<Partners />} />
                <Route path="/wall-of-champions" element={<WallOfChampions title={pageTitles.wall_of_champions} onTitleUpdate={(newTitle) => handleTitleUpdate('wall_of_champions', newTitle)} />} />
                <Route path="/hotlap-hontsa" element={<HotlapHontsa title={pageTitles.hotlap_hontsa} onTitleUpdate={(newTitle) => handleTitleUpdate('hotlap_hontsa', newTitle)} />} />
                <Route path="/admin" element={<AdminPanel titles={pageTitles} visibilities={pageVisibilities} setVisibilities={setPageVisibilities} />} />
              </Routes>
            </div>
          </main>
          <Footer />
        </div>
      </Router>
    </AdminProvider>
  );
}

export default App;